module.exports = __webpack_public_path__ + "static/media/SundropBrandsLimited.d7ab67a2.png";